import React, { useContext } from "react";

import { AppConfigContext } from "../configuration/Configuration";
import { Environment, environmentResolver } from "../types/Environment";

export type EnvironmentFeatureTogglerProps = React.PropsWithChildren<{
    excludedEnvironments: Environment[];
}>;

export const EnvironmentFeatureToggler: React.FunctionComponent<EnvironmentFeatureTogglerProps> = ({
    excludedEnvironments,
    children
}: EnvironmentFeatureTogglerProps) => {
    const { environment } = useContext(AppConfigContext);

    const resolvedEnvironment = environmentResolver(environment);

    if (excludedEnvironments.includes(resolvedEnvironment)) {
        return <></>;
    }

    return <>{children}</>;
};
